export default __webpack_public_path__ + "media/images/dashboard_icons/events-80f4fa46f31eba4b8b5a5dfe42216803.svg";